export const EMAIL_PATTERN = new RegExp(
	/^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/
)

export const ONLY_VALID_DOMAINS_EMAIL_PATTERN = new RegExp(
	/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
);

export const PHONE_NUMBER_PATTERN = new RegExp("^[0-9]([0-9\\-\\.\\s]{0,16}[0-9])?$");
